// Vendors
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TransferProject = ({
  projectID,
  builderMeta,
  _isSubscribed,
  setMainNotice,
  setShowMainNotice
}) => {
  const [transferToBuilder, setTransferToBuilder] = useState(builderMeta.ID);
  const [showTransferProject, setShowTransferProject] = useState(false);
  const [builderList, setBuilderList] = useState(null);
  const [builderListLoading, setBuilderListLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const handleTransferToBuilder = () => {
    if (transferToBuilder === builderMeta.ID) return;

    _isSubscribed = true;
    setBtnLoading(true);

    const formData = new FormData();
    formData.append('action', 'wl_pip_transfer_project');
    formData.append('pid', projectID);
    formData.append('bid', transferToBuilder);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(({ data: { success, data } }) => {
        if (_isSubscribed) {
          if (success) {
            setMainNotice({
              type: success ? 'success' : 'error',
              message: data.message
            });
            setShowMainNotice(true);
            setShowTransferProject(!showTransferProject);
          }

          setBtnLoading(false);
          setTimeout(() => location.reload(), 1500);
          _isSubscribed = false;
        }
      })
      .catch((error) => {
        console.log(error);
        setBtnLoading(false);
        _isSubscribed = false;
      });
  };

  useEffect(() => {
    if (builderList !== null) return;

    setBuilderListLoading(true);
    _isSubscribed = true;

    axios({
      method: 'post',
      url: `${window.wlPipConfig.ajaxUrl}?action=wl_pip_get_builders`
    })
      .then(({ data: { success, data } }) => {
        if (_isSubscribed) {
          if (success) {
            setBuilderList(data);
          } else {
            setBuilderList(null);
          }
          setBuilderListLoading(false);
          _isSubscribed = false;
        }
      })
      .catch((error) => {
        console.log(error);
        setBuilderListLoading(false);
        _isSubscribed = false;
      });

    return () => (_isSubscribed = false);
  }, [showTransferProject]);

  return (
    <div className="grid__col-xs-12">
      <div className="u--display-flex u--flex-direction-column">
        <div
          className={`u--margin-bottom-0 ${
            showTransferProject
              ? 'u--display-none u--margin-0'
              : 'u--display-block'
          }`}
        >
          <button
            className="btn btn--white btn--outline"
            type="button"
            onClick={() => setShowTransferProject(!showTransferProject)}
          >
            <span className="btn__content">
              <span className="btn__text">
                {showTransferProject && 'Hide'} Transfer Project to different
                Builder
              </span>
            </span>
          </button>
        </div>
        {showTransferProject && (
          <>
            <div
              style={{
                width: '100%',
                maxWidth: '600px',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <div className="form__field">
                <label className="form__label u--font-weight-bold">
                  Transfer to Builder
                </label>
                {builderListLoading && (
                  <p className="is-loading" style={{ height: '45px' }}>
                    &nbsp;
                  </p>
                )}
                {!builderListLoading && builderList && (
                  <div className="form__select form__select--lg form__input--no-shadow">
                    <select
                      name="builder"
                      className="form__input form__input--lg"
                      value={transferToBuilder}
                      onChange={(event) =>
                        setTransferToBuilder(event.currentTarget.value)
                      }
                    >
                      {Object.values(builderList).map(
                        (
                          { ID, first_name, last_name, company, user_email },
                          index
                        ) => (
                          <option key={index} value={ID}>
                            {last_name && last_name}
                            {first_name && `, ${first_name}`} ({user_email})
                            {company && ` - ${company}`}
                            {ID == builderMeta.ID ? '[current builder]' : ''}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                )}
              </div>
              <button
                className={`u--margin-right-10 btn btn--gold ${
                  btnLoading ? 'btn--loading' : ''
                }`}
                type="button"
                disabled={
                  !transferToBuilder ||
                  btnLoading ||
                  transferToBuilder === builderMeta.ID
                }
                onClick={() => handleTransferToBuilder()}
              >
                <span className="btn__content">
                  <span className="btn__text">Transfer</span>
                </span>
              </button>
              <button
                className="btn btn--red btn--outline"
                type="button"
                onClick={() => setShowTransferProject(!showTransferProject)}
              >
                <span className="btn__content">
                  <span className="btn__text">Hide</span>
                </span>
              </button>
            </div>
          </>
        )}
      </div>
      <hr />
    </div>
  );
};

export default TransferProject;
